<div class="container-fluid main_container">

  <mat-sidenav-container #drawerContainer (backdropClick)="close()" [hasBackdrop]="mode === 'over' ? true : false">
    <mat-sidenav #sidenav [opened]="toggleSideNav" [disableClose]="true" [mode]="mode"
      *ngIf="!matchUrl('/signin')" class="side-nav side-block" [class.is-collapsed]="sideCollapsed"
      (keydown.escape)="close()">
      <div class="sidenave-items ">
        <div class="logo-wrapper">
          <div class="logo-container" [class.logo-container--default]="dataManager.isDefaultLogo">
            <img (click)="toggle()" src="{{dataManager.logoUrl }}" class="logo-img"
              *ngIf="dataManager.brandingReady && dataManager.logoUrl" alt="Logo">
          </div>
          <button type="button" class="drawer-close-btn" aria-label="Close menu" (click)="close()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              [innerHTML]="closeSvg()"></svg>
          </button>
        </div>

        <!-- Mobile: the merchant switcher moved from here into the profile menu in the top bar. -->

        <nav class="nav-groups" #navGroups (scroll)="updateNavGroupsFade()" [class.nav-groups--fade-bottom]="navGroupsCanScrollDown">
          <!-- #navGroupsInner exists so there's one real element whose own box size grows
               and shrinks with the *ngFor content below, for NavDrawerComponent's
               ResizeObserver to watch — .nav-groups itself is a flex child with a stable
               viewport-driven height, so adding/removing menu items changes its
               scrollHeight but never its own observable border-box size. -->
          <div #navGroupsInner>
            <ng-container *ngFor="let group of menuGroups; trackBy: trackByGroupLabel">
              <div class="nav-section-label" *ngIf="group.label">{{group.label}}</div>
              <ul class="no-padding">
                <li class="main-list" *ngFor="let menu of group.items; trackBy: trackByMenuName"> <!--menuList-->
                  <a class="side-nav-menu menu_list" (click)="myMenuClick(menu);clearFiltersFromLocal()"
                    [routerLink]="menu.routes" routerLinkActive="link-active" [title]="menu.name"
                    *ngIf="!hasVisibleSubmenu(menu)">
                    <div class="icons"><svg class="menu-icons" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" [innerHTML]="iconSvg(menu.name)"></svg></div>
                    <div class="icon_label"> {{menu.name}}</div>
                  </a>
                  <!-- Mobile (drawer in 'over' mode): the group header only expands / collapses its sub-items
                       and the drawer stays open, so a sub-page can be picked - no routerLink there (it would
                       navigate and close the drawer). Desktop: unchanged (navigates + toggles). -->
                  <!-- Copilot review (PDT-35833): on mobile this is an <a role="button">, which (unlike a
                       real <button>) does not fire click on Space, so Space is bound as well as Enter below;
                       menuClick() preventDefaults the Space press to stop the page from scrolling. -->
                  <!-- Only a group with sub-items the drawer renders. Transactions (its only sub-item is the
                       hidden 'batch-detail') takes the plain-link branch above: a real link, which on mobile
                       navigates and closes the drawer, with link semantics (no button role / Space / caret). -->
                  <a class="side-nav-menu menu_list nav-group-toggle" [class.is-open]="ActiveMenu === menu.name"
                    *ngIf="hasVisibleSubmenu(menu)" [routerLink]="mode === 'over' ? null : menu.routes" routerLinkActive="link-active"
                    [attr.role]="mode === 'over' ? 'button' : null" [attr.tabindex]="mode === 'over' ? 0 : null"
                    [attr.aria-expanded]="mode === 'over' ? ActiveMenu === menu.name : null"
                    (keydown.enter)="mode === 'over' && menuClick(menu, $event)"
                    (keydown.space)="mode === 'over' && menuClick(menu, $event)"
                    [title]="menu.name" (click)="menuClick(menu, $event); mode !== 'over' && clearFiltersFromLocal()">
                    <div class="icons"> <svg class="menu-icons" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" [innerHTML]="iconSvg(menu.name)"></svg></div>
                    <div class="icon_label">{{menu.name}}</div>
                    <svg class="nav-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round"
                      stroke-linejoin="round" [innerHTML]="caretSvg()"></svg>
                  </a>
                  <ul *ngIf="hasVisibleSubmenu(menu)"
                    class="submenu-container" [ngStyle]="{'display': (ActiveMenu === menu.name ? 'block' : 'none')} ">
                    <li *ngFor="let submenu of menu.subMenu" class="submenu-li">
                      <a class="submenu" [routerLink]="submenu.routerLink" routerLinkActive="link-active-sub"
                        (click)="clickedSubmenu(submenu);clearFiltersFromLocal()">
                        <span class="submenu-text">{{submenu.name}}</span></a>
                    </li>
                  </ul>
                </li>
              </ul>
            </ng-container>
          </div>
        </nav>

        <button type="button" class="side-collapse-btn" (click)="toggleSideCollapse()"
          [attr.aria-label]="sideCollapsed ? 'Expand menu' : 'Collapse menu'"
          [attr.title]="sideCollapsed ? 'Expand menu' : 'Collapse menu'">
          <svg class="side-collapse-btn__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-linecap="round" stroke-linejoin="round" [innerHTML]="collapseSvg()"></svg>
          <span>Collapse</span>
        </button>
        <p class="p_vers">Version 2.0</p>
      </div>

    </mat-sidenav>

    <mat-sidenav-content class=" right_content_block " [ngClass]="{'w-100 mobile_view_right': matchUrl('/signin') }">
      <div class="app-loader" *ngIf="loadFlag">
        <img src="../../../assets/images/loader2.svg">
      </div>

      <div #routerOutlet class="page-container">
        <!-- Sticky inside the scroll container (not a flex sibling above it) so page content
             actually scrolls underneath it — that overlap is what makes the scrolled frosted-glass
             background (.pa-topbar--scrolled, topbar.component.css) visible at all. -->
        <app-topbar class="shell-toolbar" (logoClicked)="showSideNav()" [scrolled]="contentScrolled"
          *ngIf="mode === 'side' && !matchUrl('/signin')"></app-topbar>

        <!-- Mobile counterpart of .shell-toolbar above (PDT-35766): sticky on the same
             scroll container, navy surface matching the sidenav, logo + theme toggle +
             hamburger — the back arrow lives in the content area below instead of this bar. -->
        <div class="mobile-shell-topbar" *ngIf="mode === 'over' && !matchUrl('/signin')">
          <button type="button" class="mobile-shell-topbar__logo-btn" aria-label="Open navigation menu"
            (click)="showSideNav()" *ngIf="dataManager.brandingReady && dataManager.logoUrl">
            <img src="{{dataManager.logoUrl }}" class="mobile-shell-topbar__logo" alt="Logo">
          </button>
          <div class="mobile-shell-topbar__actions">
            <!-- global search (Ctrl/⌘K panel) - on desktop it is the pill in app-topbar -->
            <app-topbar-search [compact]="true"></app-topbar-search>
            <payarc-theme-toggle [compact]="true"></payarc-theme-toggle>
            <button type="button" class="mobile-shell-topbar__profile" *ngIf="userName" [matMenuTriggerFor]="profileMenu"
              [attr.aria-label]="'Account menu for ' + ((userName || '') | camalizeStr)">
              <span class="sidebar-profile__avatar">{{(userNameIcon || '') | camalizeStr}}</span>
            </button>
            <button type="button" class="btn btn-link rounded-circle toggle_btn" aria-label="Open navigation menu"
              (click)="showSideNav()">
              <img src="../../../assets/images/accordian.svg" alt="">
            </button>
          </div>
        </div>

        <!-- Mobile only: the profile menu, opened from the avatar above (next to the hamburger) - it used
             to sit in the drawer's footer. Outside the sidenav: that one is under an *ngIf, so the
             topbar could not reference a menu declared in it. Desktop has its own in app-topbar. -->
        <mat-menu #profileMenu="matMenu" class="pa-topbar-profile-panel pa-mobile-profile-panel" xPosition="before"
          yPosition="below" (closed)="showMerchants = false; name = null">
          <!-- matMenuContent: rendered lazily and change-detected with the app, so the merchant list
               below appears when "Switch merchant" is tapped (static menu content sits in the
               OnPush menu view and did not refresh) -->
          <ng-template matMenuContent>
            <div class="pa-menu-header" (click)="$event.stopPropagation()">
              <!-- the active merchant: the switcher left the drawer, so this is where it is shown now -->
              <div class="pa-menu-header__name">{{activeUser?.dba_name || activeUser?.account_name || currentAccountName || ((userName || '') | camalizeStr)}}</div>
              <div class="pa-menu-header__email" *ngIf="activeUser?.mid">MID {{activeUser.mid}}</div>
              <div class="pa-menu-header__email">{{userEmail}}</div>
            </div>
            <!-- Merchant switcher (was the select at the top of the drawer). Shown even for one merchant,
                 as that select was. Expands inside this menu: a nested mat-menu covered this one on a phone. -->
            <ng-container *ngIf="currentUsers?.length">
              <button mat-menu-item class="pa-menu-switch" [attr.aria-expanded]="showMerchants"
                (click)="$event.stopPropagation(); showMerchants = !showMerchants">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" aria-hidden="true">
                  <path d="M3 9l1.5-5h15L21 9"/><path d="M3 9h18v2a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z"/><path d="M5 13v7h14v-7"/>
                </svg>
                Switch merchant
                <svg class="pa-menu-switch__caret" [class.is-open]="showMerchants" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" [innerHTML]="caretSvg()"></svg>
              </button>
              <div class="pa-menu-merchants" *ngIf="showMerchants" (click)="$event.stopPropagation()">
                <input class="pa-menu-filter" placeholder="Filter by name" aria-label="Filter merchants" [(ngModel)]="name"
                  (keydown)="$event.key !== 'Escape' && $event.stopPropagation()">
                <div class="pa-menu-scroll">
                  <button mat-menu-item *ngFor="let account of currentUsers | search:'account_name,mid,dba_name':name"
                    (click)="switchAccount(account.id, account.account_name)"
                    [class.activeAccount]="account.id === currentAccountId" class="pa-merchant-row">
                    <span class="pa-merchant-row__name">{{account.dba_name || account.account_name || account.id}}</span>
                    <span class="pa-merchant-row__mid" *ngIf="account.mid">MID {{account.mid}}</span>
                  </button>
                </div>
              </div>
            </ng-container>
            <!-- same items / icons as the desktop profile menu (tool-bar.component.html) -->
            <button mat-menu-item class="pa-menu-item-icon" (click)="myprofile()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-6 8-6s8 2 8 6"/>
              </svg>
              Profile
            </button>
            <button mat-menu-item class="pa-menu-item-icon" (click)="toUpdateContact()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 7 8.5 6 8.5-6"/>
              </svg>
              Contact
            </button>
            <button mat-menu-item class="pa-menu-item-icon pa-menu-signout" (click)="signOut()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
              Signout
            </button>
          </ng-template>
        </mat-menu>


        <div class="body-contain" id='body_contain'>
          <div class="row no-margin">
            <div class="col-md-12 no-padding">
              <button type="button" class="btn btn-link rounded-circle go_back mobile-back-btn"
                *ngIf="mode === 'over' && !matchUrl('/signin')" aria-label="Go back" (click)="goBack()">
                <img src="../../../assets/images/back.svg" alt="">
              </button>
              <router-outlet (activate)="onActivate(routerOutlet)"></router-outlet>
            </div>
          </div>
        </div>
        <div class="row no-margin" *ngIf="!matchUrl('/signin')">
          <div class="col-md-12 no-padding">
            <app-footer></app-footer>

          </div>
        </div>
      </div>

    </mat-sidenav-content>

  </mat-sidenav-container>
</div>